'use client';

import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import { useRouter, useSearchParams } from 'next/navigation';
import { BlogCard, BlogCardProps } from '@peaksandpies-paychex/ui/blog-card';
import { IconButton } from '@peaksandpies-paychex/ui/button';
import { Tag } from '@peaksandpies-paychex/ui/tag';
import { Typography } from '@peaksandpies-paychex/ui/typography';
import { useWindowSize } from '@/lib/hooks/use-window-size';
import { Pagination } from '../pagination/pagination';
interface CardsProps extends BlogCardProps {
  id: string;
}
interface FilterProps {
  blogType: 'blogEntry' | 'salaryUpdatesEntry';
  tags: string[];
  cards: CardsProps[];
  draftMode: boolean;
  language: 'de' | 'en';
  currentPage?: number;
  totalPages?: number;
  topics?: Array<string>;
  isNotFound?: boolean;
}
export const Filter: React.FC<FilterProps> = t0 => {
  const $ = _c(52);
  const {
    cards,
    tags,
    language,
    currentPage: t1,
    totalPages,
    topics,
    isNotFound
  } = t0;
  const currentPage = t1 === undefined ? 1 : t1;
  const router = useRouter();
  const urlSearchParams = useSearchParams();
  let t2;
  if ($[0] !== urlSearchParams) {
    t2 = new URLSearchParams(urlSearchParams.toString());
    $[0] = urlSearchParams;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const params = t2;
  const [showMore, setShowMore] = useState(false);
  const {
    width
  } = useWindowSize();
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => setShowMore(_temp);
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const toggleShowMore = t3;
  let t4;
  if ($[3] !== showMore || $[4] !== tags || $[5] !== width) {
    t4 = width && width < 1024 ? showMore ? tags : tags.slice(0, 12) : tags;
    $[3] = showMore;
    $[4] = tags;
    $[5] = width;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const displayedTags = t4;
  let t5;
  if ($[7] !== params || $[8] !== router || $[9] !== topics) {
    t5 = filterValue => {
      if (topics && topics.includes(filterValue)) {
        params.delete("topics");
        topics.filter(topic => topic !== filterValue).forEach(topic_0 => params.append("topics", topic_0));
      } else {
        params.append("topics", filterValue);
      }
      params.set("page", "1");
      router.push(`?${params.toString()}`, {
        scroll: false
      });
    };
    $[7] = params;
    $[8] = router;
    $[9] = topics;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const filterItem = t5;
  if (isNotFound) {
    const t6 = language === "de" ? "Das k\xF6nnte Sie auch interessieren" : "You may also like";
    let t7;
    if ($[11] !== t6) {
      t7 = <Typography variant="H2" alignment="center">{t6}</Typography>;
      $[11] = t6;
      $[12] = t7;
    } else {
      t7 = $[12];
    }
    let t8;
    if ($[13] !== cards || $[14] !== language) {
      let t9;
      if ($[16] !== language) {
        t9 = (card, idx) => <BlogCard {...card} key={idx} language={language} />;
        $[16] = language;
        $[17] = t9;
      } else {
        t9 = $[17];
      }
      t8 = cards.map(t9);
      $[13] = cards;
      $[14] = language;
      $[15] = t8;
    } else {
      t8 = $[15];
    }
    let t9;
    if ($[18] !== t8) {
      t9 = <div className="mt-6 mb-8 grid grid-cols-[repeat(1,minmax(0,480px))] justify-center gap-6 m1:grid-cols-2 m2:mb-10 m2:grid-cols-3 l:mt-10 l:mb-16 xl:mt-16 xl:mb-20 xl:gap-8">{t8}</div>;
      $[18] = t8;
      $[19] = t9;
    } else {
      t9 = $[19];
    }
    let t10;
    if ($[20] !== t7 || $[21] !== t9) {
      t10 = <div className="mb-12 max-w-[1120px] gap-12 m1:mb-14 l:mb-20 l:gap-16">{t7}{t9}</div>;
      $[20] = t7;
      $[21] = t9;
      $[22] = t10;
    } else {
      t10 = $[22];
    }
    return t10;
  }
  let t6;
  if ($[23] !== displayedTags || $[24] !== filterItem || $[25] !== topics) {
    let t7;
    if ($[27] !== filterItem || $[28] !== topics) {
      t7 = (tag, idx_0) => <Tag name={tag} key={idx_0} filterItem={filterItem} isSelected={topics?.includes(tag)} />;
      $[27] = filterItem;
      $[28] = topics;
      $[29] = t7;
    } else {
      t7 = $[29];
    }
    t6 = displayedTags.map(t7);
    $[23] = displayedTags;
    $[24] = filterItem;
    $[25] = topics;
    $[26] = t6;
  } else {
    t6 = $[26];
  }
  let t7;
  if ($[30] !== t6) {
    t7 = <div className="flex flex-wrap justify-center gap-2">{t6}</div>;
    $[30] = t6;
    $[31] = t7;
  } else {
    t7 = $[31];
  }
  let t8;
  if ($[32] !== showMore || $[33] !== tags.length) {
    t8 = tags.length > 12 && <div className={`flex w-full justify-center m2:hidden ${showMore ? "mt-3" : "absolute -bottom-11 h-[84px] items-end bg-linear-to-t from-white via-white"}`}><IconButton iconName={showMore ? "minus" : "plus"} variant="primary" size="x-tiny" onClick={toggleShowMore} /></div>;
    $[32] = showMore;
    $[33] = tags.length;
    $[34] = t8;
  } else {
    t8 = $[34];
  }
  let t9;
  if ($[35] !== t7 || $[36] !== t8) {
    t9 = <div className="mb-12 max-w-[880px] m1:mb-14 l:mb-20">{t7}{t8}</div>;
    $[35] = t7;
    $[36] = t8;
    $[37] = t9;
  } else {
    t9 = $[37];
  }
  let t10;
  if ($[38] !== cards || $[39] !== language) {
    let t11;
    if ($[41] !== language) {
      t11 = (card_0, idx_1) => <BlogCard {...card_0} key={idx_1} language={language} />;
      $[41] = language;
      $[42] = t11;
    } else {
      t11 = $[42];
    }
    t10 = cards.map(t11);
    $[38] = cards;
    $[39] = language;
    $[40] = t10;
  } else {
    t10 = $[40];
  }
  let t11;
  if ($[43] !== t10) {
    t11 = <div className="mt-6 mb-8 grid grid-cols-[repeat(1,minmax(0,480px))] justify-center gap-6 m1:grid-cols-2 m2:mb-10 m2:grid-cols-3 l:mt-10 l:mb-16 xl:mt-16 xl:mb-20 xl:gap-8">{t10}</div>;
    $[43] = t10;
    $[44] = t11;
  } else {
    t11 = $[44];
  }
  let t12;
  if ($[45] !== currentPage || $[46] !== totalPages) {
    t12 = totalPages && totalPages > 1 && <Pagination pageCount={totalPages} currentPage={currentPage} />;
    $[45] = currentPage;
    $[46] = totalPages;
    $[47] = t12;
  } else {
    t12 = $[47];
  }
  let t13;
  if ($[48] !== t11 || $[49] !== t12 || $[50] !== t9) {
    t13 = <>{t9}{t11}{t12}</>;
    $[48] = t11;
    $[49] = t12;
    $[50] = t9;
    $[51] = t13;
  } else {
    t13 = $[51];
  }
  return t13;
};
function _temp(prev) {
  return !prev;
}